/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chot_So_ApproveInputs */

const vi_chot_so_approve = /** @type {(inputs: Chot_So_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duyệt`)
};

/**

* @param {Chot_So_ApproveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const chot_so_approve = /** @type {((inputs?: Chot_So_ApproveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chot_So_ApproveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_chot_so_approve(inputs)
});